var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.762,
    height: 12.469,
    viewBox: "0 0 11.762 12.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-up",
    "data-name": "Icon ionic-md-arrow-round-up",
    d: "M17.759,10.837,13.012,5.944a1.079,1.079,0,0,0-.794-.319H12.2a1.079,1.079,0,0,0-.794.319L6.662,10.837a1.048,1.048,0,0,0,0,1.531,1.172,1.172,0,0,0,1.6,0l2.813-2.941v7.582a1.135,1.135,0,0,0,2.268,0V9.427l2.813,2.941a1.172,1.172,0,0,0,1.6,0A1.048,1.048,0,0,0,17.759,10.837Z",
    transform: "translate(-6.33 -5.625)",
    fill: "#098551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenicon);
export default __webpack_public_path__ + "static/media/greenicon.18647f59e19998a901caba42c9d11629.svg";
export { ForwardRef as ReactComponent };